module.exports = __webpack_public_path__ + "img/ringPerimeter@2x.6082176.jpg";